import { render } from "./campaign_grid_card.vue?vue&type=template&id=4f125aaa&scoped=true"
import script from "./campaign_grid_card.vue?vue&type=script&lang=js"
export * from "./campaign_grid_card.vue?vue&type=script&lang=js"

import "./campaign_grid_card.vue?vue&type=style&index=0&id=4f125aaa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f125aaa"]])

export default __exports__